import { Injectable } from '@angular/core';
import { Firestore, doc, setDoc, docData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { switchMap, filter } from 'rxjs/operators';
import { DataService } from './data';

interface ProjectionState {
  songId: string | null;
  paragraphIndex: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class ProjectionService {

  constructor(
    private firestore: Firestore, 
    private dataService: DataService) {}

  private getProjectionDocRef(churchId: string) {
    return doc(this.firestore, `iglesias/${churchId}/projectionState/current`);
  }
}
